import React, { useState, useEffect, useReducer } from "react";
import PropTypes from "prop-types";
import Input from "./Input";
import Dialog from "../dialogs/Dialog";
import Button from "../buttons/Button";
import "./Textarea.scss";

/**
 * Text area component
 * @module
 * @param {string} name - Name
 * @param {func} onChange - Function invoked on value change
 * @param {bool} [disabled] - Is textarea readonly?
 * @param {string} [value] - Current value
 * @param {bool} [required] - Required
 * @param {string} title - Textarea title
 * @param {number} [tabIndex] - Textarea tab index
 * @param {bool} [readOnly] - Read only
 * @param {number} [minLength] - Minimum length
 * @param {number} [maxLength] - Maximum length
 * @param {bool} [defaultExpanded] - Expands the textarea
 */
const TextareaComponent = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState(null);

  useEffect(() => {
    setValue(props.value || "");
  }, [props.primaryFieldValue]);

  const handleOpen = () => {
    setIsOpen(true);
    setValue(props.value);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleConfirm = () => {
    handleClose();
    props.onChange(props.name, value);
  };

  const handleClick = (e) => {
    if (e.detail === 2) {
      handleOpen();
    }
  };

  const handleInsertClick = () => {
    let _value = "";
    if (props.value) {
      if (props.value.indexOf(props.insertValue) !== -1) {
        _value = props.value;
      } else {
        _value = `${props.insertValue} - ${props.value}`;
      }
    } else {
      _value = props.insertValue;
    }
    props.onChange(props.name, _value);
  };

  const onBlur = () => {
    if (props.onBlur) {
      props.onBlur();
    }
  };

  return (
    <>
      {props.defaultExpanded ? (
        <div className={`form-input textarea ${props.disabled ? "disabled-field" : props.required ? "required-field" : "default-field"}`}>
          <textarea
            className="k-textarea"
            placeholder={props.placeholder}
            value={value}
            //value={props.value !== undefined && props.value !== null ? props.value : value}
            // disabled={this.props.disabled}
            readOnly={props.disabled}
            onChange={(e) => {
              const value = e.target.value;
              if (props.readOnly || (props.maxLength && value.length >= props.maxLength)) return;
              setValue(value);
              props.onChange(props.name, value);
            }}
          />
          {props.maxLength && (
            <div className="charCounter">
              <span
                className={value?.length === props.maxLength - 1 ? 'charCounterRed' : ''}
              >
                {value?.length || props.value?.length || 0}/{props.maxLength}
              </span>
            </div>
          )}
        </div>
      ) : (
        <>
          <Input
            className={`form-input textarea ${props.disabled ? "disabled-field" : props.required ? "required-field" : "default-field"}`}
            name={props.name}
            value={!!props.value ? props.value.replace(/[\n]/g, ' ') : props.value}
            disabled={props.disabled}
            onChange={props.onChange}
            onClick={handleClick}
            required={props.required}
            tabIndex={props.tabIndex}
            minLength={props.minLength}
            maxLength={props.maxLength}
            onBlur={onBlur}
            placeholder={props.placeholder}
          />
          {props.enableInsertValue && (
            <Button
              icon={'paste'}
              onClick={handleInsertClick}
              title={'Vložiť opis CG HD'}
            />
          )}
          <Dialog
            isOpen={isOpen}
            onClose={handleClose}
            onConfirm={handleConfirm}
            title={props.title}
          >
            <div className="textarea">
              <textarea
                className="k-textarea"
                value={value || ''}
                // disabled={this.props.disabled}
                readOnly={props.disabled}
                onChange={(e) => {
                  const value = e.target.value;
                  if (props.readOnly || (props.maxLength && value.length >= props.maxLength))
                    return;
                  setValue(value);
                }}
              />
            </div>
          </Dialog>
        </>
      )}
    </>
  );
};


TextareaComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  required: PropTypes.bool,
  title: PropTypes.string.isRequired,
  tabIndex: PropTypes.number,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  enableInsertValue: PropTypes.bool,
  insertValue: PropTypes.string,
};

export default TextareaComponent;
